import React from 'react';
import cn from 'classnames';
import ReplaceableImagePreview from '../ReplaceableImagePreview';

import s from './ImagePreviewWithDisplayOptions.scss';

interface Props {
  compact?: boolean;
}

const ImagePreviewWithDisplayOptions: React.FC<Props> = ({ compact }) => (
  <div className={cn(s['root'], compact && s['compact'])}>
    <ReplaceableImagePreview className={s['preview']} />
  </div>
);
ImagePreviewWithDisplayOptions.displayName = 'ImagePreviewWithDisplayOptions';

export default ImagePreviewWithDisplayOptions;
